@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.Hyperlink {
  @extend %font-family-primary;

  font-size: $font-size-normal;
  display: inline-grid;
  color: $theme-color-links;
  line-height: 18px;
  align-items: baseline;
  grid-auto-flow: column;
  gap: 4px;
  font-weight: $font-weight-semibold;
  text-decoration: none;

  svg {
    display: inline-flex;
    align-self: center;
    height: 12px; // the icon should follow font size
    width: 12px;
  }

  strong {
    font-weight: $font-weight-bold;
  }

  &:hover {
    color: $theme-color-hover;
    text-decoration: underline;
  }

  &.InlineLink {
    font-weight: $font-weight-normal;
  }
}

.SecondaryHyperlink {
  color: $theme-color-secondary-links !important;
}